var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSilverRank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16216",
    "data-name": "Rectangle 16216",
    width: 13.253,
    height: 15.975,
    fill: "#f7f7f7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15740",
    "data-name": "Group 15740",
    transform: "translate(-1031 -389)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_730",
    "data-name": "Ellipse 730",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(1031 389)",
    fill: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15737",
    "data-name": "Group 15737",
    transform: "translate(1038.374 395.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15488",
    "data-name": "Group 15488",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41249",
    "data-name": "Path 41249",
    d: "M14.773,0A6.117,6.117,0,1,1,8.679,6.095,6.12,6.12,0,0,1,14.773,0m-.095,2.868a.418.418,0,0,0-.352.276c-.21.423-.422.845-.624,1.272a.255.255,0,0,1-.216.165c-.453.062-.9.135-1.357.191a.5.5,0,0,0-.473.32.5.5,0,0,0,.177.556c.34.322.673.651,1,.982a.251.251,0,0,1,.071.183c-.074.482-.154.963-.244,1.443a.472.472,0,0,0,.181.51.462.462,0,0,0,.528.018c.408-.216.821-.425,1.225-.648a.3.3,0,0,1,.339,0c.413.229.834.444,1.252.663a.444.444,0,0,0,.512-.039.466.466,0,0,0,.172-.485c-.086-.475-.159-.952-.246-1.427a.209.209,0,0,1,.067-.218c.345-.331.684-.669,1.029-1a.478.478,0,0,0-.287-.853c-.473-.065-.945-.139-1.418-.2a.2.2,0,0,1-.17-.128c-.21-.434-.427-.865-.639-1.3a.5.5,0,0,0-.527-.276",
    transform: "translate(-8.136 -0.001)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41250",
    "data-name": "Path 41250",
    d: "M1.385,172.822a7.139,7.139,0,0,0,1.857,1.485,7.024,7.024,0,0,0,2.238.778c-.018.053-.029.1-.046.136-.36.811-.723,1.62-1.08,2.432-.087.2-.216.349-.438.339a.527.527,0,0,1-.488-.35c-.237-.57-.486-1.135-.731-1.7-.022-.052-.047-.1-.076-.165l-1.269.43q-.354.119-.708.238a.457.457,0,0,1-.514-.117.45.45,0,0,1-.081-.521q.647-1.466,1.3-2.929a.556.556,0,0,1,.034-.054",
    transform: "translate(0 -162.019)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41251",
    "data-name": "Path 41251",
    d: "M127.361,175.673l-.538,1.244c-.1.228-.194.459-.3.685a.49.49,0,0,1-.45.286.422.422,0,0,1-.413-.28q-.574-1.286-1.145-2.573a.271.271,0,0,1-.007-.052,7.065,7.065,0,0,0,4.1-2.273l.379.852q.468,1.052.935,2.1a.473.473,0,0,1-.132.614.518.518,0,0,1-.5.042q-.9-.31-1.811-.617c-.034-.011-.068-.02-.114-.034",
    transform: "translate(-116.728 -161.914)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41252",
    "data-name": "Path 41252",
    d: "M82.493,71.139c-.184.2-.355.4-.545.58a.577.577,0,0,0-.181.59c.055.252.088.51.134.793-.242-.126-.47-.232-.685-.361a.6.6,0,0,0-.686,0c-.212.129-.439.234-.685.363.048-.286.084-.55.137-.81a.55.55,0,0,0-.173-.563c-.161-.147-.311-.306-.472-.455a.5.5,0,0,0-.143-.065l.054-.071c.25-.037.5-.081.749-.108a.577.577,0,0,0,.515-.365c.1-.237.227-.465.357-.726.039.072.069.123.095.175.093.186.193.368.274.559a.568.568,0,0,0,.519.358c.25.026.5.07.735.1",
    transform: "translate(-74.244 -65.571)",
    fill: "#f7f7f7"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverRank);
export default __webpack_public_path__ + "static/media/silver-rank.4480499e8fec811c507828e23e6b9849.svg";
export { ForwardRef as ReactComponent };